import { WISHLIST_API_PATHS } from '../constants/wishlist'
import type { ApiWishlistItem } from './types'
import { apiRequest } from './client'

export function fetchWishlist(): Promise<ApiWishlistItem[]> {
  return apiRequest<ApiWishlistItem[]>(WISHLIST_API_PATHS.root, { auth: true })
}

export function fetchWishlistProductIds(): Promise<string[]> {
  return apiRequest<string[]>(WISHLIST_API_PATHS.productIds, { auth: true })
}

export function addWishlistItem(productId: string): Promise<ApiWishlistItem> {
  return apiRequest<ApiWishlistItem>(WISHLIST_API_PATHS.root, {
    method: 'POST',
    auth: true,
    body: { productId },
  })
}

export function removeWishlistItem(productId: string): Promise<{ ok: true }> {
  return apiRequest<{ ok: true }>(WISHLIST_API_PATHS.item(productId), {
    method: 'DELETE',
    auth: true,
  })
}
